import { useOutletContext } from 'react-router-dom'

import FormFieldEditModal from 'modules/expenses/components/FormFieldEditModal'
import {
  CustomizationField,
  findField,
  findFieldBy,
  useExpensesCustomization,
} from 'modules/expenses/hooks/useExpensesCustomization'

import { RouteContextParams } from './FormsCustomizationRootPage'

const getFieldFromParams = (
  fields: CustomizationField[],
  { id, identifier, resource_type }: RouteContextParams
) => {
  if (id) {
    return findField(fields || [], id)
  } else if (identifier) {
    return findFieldBy(fields || [], resource_type, identifier)
  } else {
    return undefined
  }
}

const FormFieldEditModalPage = () => {
  const routeContextParams = useOutletContext<RouteContextParams>()
  const { fields: allFields } = useExpensesCustomization()

  if (!allFields || !routeContextParams) {
    return null
  }

  const field = getFieldFromParams(allFields, routeContextParams)

  if (!field) {
    return null
  }

  return <FormFieldEditModal field={field} allFields={allFields} />
}

export default FormFieldEditModalPage
